// import { useEffect, useState, useRef } from "react";
// import "./dashboard.css";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import L from "leaflet";
// import { FaCircle, FaArrowRight, FaBell } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// import axios from "axios";
// import "leaflet/dist/leaflet.css";
// import toast from "react-hot-toast";
// import SiteStatusCard from "../../StatusTile/SiteStatuscard.js";
// import CreateCustomer from "./CreateCustomer";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
// import apiService from "../../../utils/apiservice";

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// const API_URL = process.env.REACT_APP_API_DJANGO_URL;

// // Fix leaflet icon
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl:
//     "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
//   iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
//   shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
// });

// const Dashboard = () => {
//   const [sites, setSites] = useState([]);
//   const [assets, setAssets] = useState([]);
//   const [customers, setCustomers] = useState([]);
//   const [selectedCustomer, setSelectedCustomer] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [selectedSite, setSelectedSite] = useState(null);
//   const navigate = useNavigate();
//   const selectedCustomerRef = useRef("");

//   const [unreadCount, setUnreadCount] = useState(0);
//   const lastAlarmTimeRef = useRef(0);
//   const [showCustomerPopup, setShowCustomerPopup] = useState(false);
//   const [refreshing, setRefreshing] = useState(false); // background refresh

//   const formatDtmToDateTime = (dtm) => {
//     if (!dtm || dtm.length < 14) return "N/A";
//     const year = dtm.substring(0, 4);
//     const month = dtm.substring(4, 6);
//     const day = dtm.substring(6, 8);
//     const hours = dtm.substring(8, 10);
//     const minutes = dtm.substring(10, 12);
//     const seconds = dtm.substring(12, 14);
//     return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
//   };
//   useEffect(() => {
//     // ⏳ Delay ONLY for organization check
//     const timer = setTimeout(() => {
//       checkCustomerStatus();
//     }, 500);

//     const init = async () => {
//       setLoading(true);

//       try {
//         const customerId = await fetchCustomers();

//         await Promise.all([
//           fetchSitesWithHealth(customerId),
//           fetchAssetsWithLocation(customerId),
//           fetchAlarms(),
//         ]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     init();

//     // const interval = setInterval(() => {
//     //   fetchSitesWithHealth();
//     //   fetchAssetsWithLocation();
//     //   fetchAlarms();
//     // }, 60000);

//     const interval = setInterval(() => {
//       const currentCustomer =
//         localStorage.getItem("role") === "SA"
//           ? selectedCustomerRef.current
//           : localStorage.getItem("customer_id");

//       fetchSitesWithHealth(currentCustomer);
//       fetchAssetsWithLocation(currentCustomer);
//       fetchAlarms();
//     }, 60000);
//     return () => clearInterval(interval);
//   }, []);

//   const checkCustomerStatus = async () => {
//     // ✅ Use consistent key
//     const customerId = localStorage.getItem("customerId");
//     if (customerId) {
//       setShowCustomerPopup(false);
//       return;
//     }

//     try {
//       const token = localStorage.getItem("accessToken");
//       if (!token) return;

//       const response = await axios.get(`${API_URL}/api/check_organization/`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       // ✅ Only show popup if API says false AND no localStorage
//       if (!response.data?.status && !localStorage.getItem("customerId")) {
//         setShowCustomerPopup(true);
//       } else {
//         setShowCustomerPopup(false);
//         // ✅ Save customerId to localStorage if API provides it
//         if (response.data.customerId) {
//           localStorage.setItem("customerId", response.data.customerId);
//         }
//       }
//     } catch (err) {
//       console.error("Check org API error:", err);
//       if (!localStorage.getItem("customerId")) {
//         setShowCustomerPopup(true);
//       } else {
//         setShowCustomerPopup(false);
//       }
//     }
//   };

//   const fetchCustomers = async () => {
//     const role = localStorage.getItem("role");

//     // only Super Admin can fetch customer list
//     if (role !== "SA") return;

//     try {
//       const token = localStorage.getItem("accessToken");

//       // const res = await axios.get(`${API_URL}/api/get_customers/`, {
//       //   headers: {
//       //     Authorization: `Bearer ${token}`,
//       //     Accept: "application/json",
//       //   },
//       // });
//       const res = await apiService({
//         url: `${API_URL}/api/get_customers/`,
//         method: "GET",
//       });
//       const customerList = res.data || [];
//       setCustomers(customerList);

//       // if (customerList.length > 0) {
//       //   const firstCustomerId = customerList[0].tb_customer_id;
//       //   setSelectedCustomer(firstCustomerId);
//       //   return firstCustomerId;
//       // }
//       if (customerList.length > 0) {
//         const firstCustomerId = customerList[0].tb_customer_id;
//         setSelectedCustomer(firstCustomerId);
//         selectedCustomerRef.current = firstCustomerId;
//         return firstCustomerId;
//       }

//       return null;
//     } catch (err) {
//       console.error("Customer fetch error:", err);
//     }
//   };

//   const fetchSitesWithHealth = async (passedCustomerId = null) => {
//     try {
//       if (sites.length === 0) {
//         setLoading(true); // only first load
//       } else {
//         setRefreshing(true); // background refresh
//       }
//       // setLoading(true); // ✅ START loading here
//       const token = localStorage.getItem("accessToken");
//       const role = localStorage.getItem("role");

//       const customerId =
//         role === "SA"
//           ? passedCustomerId || selectedCustomer
//           : localStorage.getItem("customer_id");
//       const userId = localStorage.getItem("userId");

//       const config = {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//           "Content-Type": "application/json",
//         },
//         data: {},
//       };
//       let siteItems = [];
//       if (role === "S") {
//         // Supervisor
//         const res = await axios.get(
//           `${API_URL}/api/supervisor_sites/${userId}/`,
//           config,
//         ); // Convert response format
//         siteItems = (res.data.sites || []).map((s) => ({
//           asset_id: s.asset_id,
//           name: s.name,
//           latitude: s.latitude,
//           longitude: s.longitude,
//         }));
//       } else if (role === "SE") {
//         // ✅ Site Engineer
//         const res = await axios.get(
//           `${API_URL}/api/engineer_sites/${userId}/`,
//           config,
//         );

//         siteItems = (res.data.sites || []).map((s) => ({
//           asset_id: s.asset_id,
//           name: s.site_name, // ⚠️ IMPORTANT (different key)
//           latitude: s.latitude,
//           longitude: s.longitude,
//         }));
//       } else {
//         // 1. Get Customer Sites (Django Response: { "data": [{ "asset_id": "...", "name": "..." }] })
//         const res = await axios.get(
//           `${API_URL}/api/get_customer_sites/${customerId}/`,
//           config,
//         );
//         siteItems = res.data.data || [];
//       }
//       // const siteItems = siteRes.data.data || [];

//       const siteCards = await Promise.all(
//         siteItems.map(async (site) => {
//           const assetId = site.asset_id;
//           const siteName = site.name;

//           // IMPORTANT: config must contain Authorization, Accept, and Content-Type

//           try {
//             // 1. Get Site Devices - Now including config!
//             const deviceRes = await axios.get(
//               `${API_URL}/api/site_devices/${assetId}/`,
//               config,
//             );

//             const devices = deviceRes.data.devices || [];
//             const primaryDevice = devices[0];

//             const deviceName =
//               primaryDevice.name || primaryDevice.device_name || "";

//             if (!primaryDevice) {
//               return {
//                 siteId: assetId,
//                 siteName,
//                 supplyHealth: null,
//                 isActive: false,
//               };
//             }

//             const deviceId = primaryDevice.device_id;

//             const telemetryRes = await axios.get(
//               `${API_URL}/api/device_telemetry/${deviceId}/?keys=data`,
//               config,
//             );

//             const telData = telemetryRes.data.telemetry?.data || [];

//             let parsedTelemetry = {};
//             let modbusData = {};
//             let isActive = false; // Default OFFLINE

//             if (telData.length > 0 && telData[0].value !== null) {
//               try {
//                 parsedTelemetry = JSON.parse(telData[0].value);
//                 modbusData = parsedTelemetry.modbus?.[0] || {};

//                 // Get telemetry timestamp
//                 const lastTelemetryTs = telData[0].ts;

//                 // Current time
//                 const now = Date.now();

//                 // Difference in minutes
//                 const diffMinutes = (now - lastTelemetryTs) / (1000 * 60);

//                 // ONLINE if telemetry received within last 2 minutes
//                 isActive = diffMinutes <= 2;

//                 console.log(
//                   `${siteName} Last Telemetry Age: ${diffMinutes.toFixed(2)} mins`,
//                 );
//               } catch (e) {
//                 console.error("JSON parse error for site:", siteName);
//               }
//             }

//             // 2. Get Telemetry - Including config!
//             // 2. Get Telemetry
//             // const telemetryRes = await axios.get(
//             //   `${API_URL}/api/device_telemetry/${deviceId}/?keys=data`,
//             //   config,
//             // );

//             // const telData = telemetryRes.data.telemetry?.data || [];
//             // let parsedTelemetry = {};
//             // let modbusData = {};

//             // // FIX: Check if value exists and is NOT null
//             // if (telData.length > 0 && telData[0].value !== null) {
//             //   try {
//             //     parsedTelemetry = JSON.parse(telData[0].value);
//             //     modbusData = parsedTelemetry.modbus?.[0] || {};
//             //   } catch (e) {
//             //     console.error("JSON parse error for site:", siteName);
//             //   }
//             // }

//             // 3. Get Device Status - This will now be reached even if telemetry is null!
//             // const statusRes = await axios.get(
//             //   `${API_URL}/api/get_device_status/${deviceId}/`,
//             //   config,
//             // );

//             // const isActive = statusRes.data.active ?? false;
//             // const deviceName = statusRes.data.name ?? "";

//             // ✅ NEW: Fetch grouped telemetry
//             const groupedData = await fetchGroupedTelemetry(deviceId, config);
//             // ✅ NEW: Fetch latest alarm
//             const latestAlarm = await fetchLatestAlarms(deviceId, config);

//             return {
//               siteId: assetId,
//               siteName,
//               deviceId,
//               deviceName,
//               supplyHealth: modbusData.Supply_H ?? null,
//               lastUpdated: parsedTelemetry.dtm
//                 ? formatDtmToDateTime(parsedTelemetry.dtm)
//                 : "N/A",
//               isActive: isActive,
//               telemetry: parsedTelemetry,
//               groupedTelemetry: groupedData,
//               latestAlarms: latestAlarm,
//             };
//           } catch (innerErr) {
//             console.error(
//               `Error processing site ${siteName}:`,
//               innerErr.response?.data || innerErr.message,
//             );
//             return {
//               siteId: assetId,
//               siteName,
//               supplyHealth: null,
//               isActive: false,
//             };
//           }
//         }),
//       );
//       setSites((prevSites) => {
//         return siteCards.map((newSite) => {
//           const oldSite = prevSites.find((s) => s.siteId === newSite.siteId);

//           return JSON.stringify(oldSite) !== JSON.stringify(newSite)
//             ? newSite
//             : oldSite;
//         });
//       });
//     } catch (err) {
//       console.error("Master Site fetch error:", err);
//     } finally {
//       setLoading(false); // ✅ STOP loading ONLY after everything completes
//       setRefreshing(false);
//     }
//   };

//   const fetchAssetsWithLocation = async (passedCustomerId = null) => {
//     try {
//       const token = localStorage.getItem("accessToken");
//       const role = localStorage.getItem("role");

//       const customerId =
//         role === "SA"
//           ? passedCustomerId || selectedCustomer
//           : localStorage.getItem("customer_id");
//       const userId = localStorage.getItem("userId");

//       let siteItems = [];
//       let res;

//       if (role === "S") {
//         // Using your local DB Site data via the middle layer
//         // Supervisor API
//         const res = await axios.get(
//           `${API_URL}/api/supervisor_sites/${userId}/`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               Accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             data: {},
//           },
//         );
//         siteItems = (res.data.sites || []).map((s) => ({
//           asset_id: s.asset_id,
//           name: s.name,
//           latitude: s.latitude,
//           longitude: s.longitude,
//         }));
//       } else if (role === "SE") {
//         const res = await axios.get(
//           `${API_URL}/api/engineer_sites/${userId}/`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               Accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             data: {},
//           },
//         );

//         siteItems = (res.data.sites || []).map((s) => ({
//           asset_id: s.asset_id,
//           name: s.site_name,
//           latitude: s.latitude,
//           longitude: s.longitude,
//         }));
//       } else {
//         // Customer API
//         const res = await axios.get(
//          `${API_URL}/api/get_customer_sites/${customerId}/`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               Accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             data: {},
//           },
//         );

//         siteItems = res.data.data || [];
//       }

//       const assetsWithLoc = (siteItems || []).map((site) => ({
//         id: { id: site.asset_id },
//         name: site.name,
//         latitude: site.latitude,
//         longitude: site.longitude,
//       }));

//       setAssets(assetsWithLoc);
//       // setLoading(false);
//     } catch (err) {
//       console.error("Asset location fetch error:", err);
//       // setLoading(false);
//     }
//   };

//   const fetchAlarms = async () => {
//     try {
//       const token = localStorage.getItem("accessToken");
//       // Ensure this URL matches your Django path exactly
//       const res = await axios.get(`${API_URL}/api/get_alarms_notification/`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//           // "Content-Type": "application/json"
//         },
//       });

//       const alarmList = res.data.data || [];
//       const active = alarmList.filter((a) => !a.cleared);

//       if (alarmList.length > 0) {
//         const newestTime = alarmList[0].createdTime;
//         if (
//           lastAlarmTimeRef.current !== 0 &&
//           newestTime > lastAlarmTimeRef.current
//         ) {
//           toast.error("🚨 New Alarm Triggered!");
//           localStorage.removeItem("alarmsViewed");
//         }
//         lastAlarmTimeRef.current = newestTime;
//       }

//       setUnreadCount(
//         localStorage.getItem("alarmsViewed") === "true" ? 0 : active.length,
//       );
//     } catch (err) {
//       console.error("Alarm fetch error:", err);
//     }
//   };

//   const fetchGroupedTelemetry = async (deviceId, config) => {
//     try {
//       const res = await axios.get(
//         `${API_URL}/api/get_grouped_telemetry/${deviceId}/`,
//         config,
//       );

//       return res.data?.groups || [];
//     } catch (err) {
//       console.error("Grouped telemetry error:", err);
//       return [];
//     }
//   };

//   const fetchLatestAlarms = async (deviceId, config) => {
//     try {
//       const res = await axios.get(
//         `${API_URL}/api/get_latest_alarms/?deviceId=${deviceId}`,
//         config,
//       );

//       // API returns array in data
//       const alarms = res.data?.data || res.data || [];

//       return alarms || []; // take latest only
//     } catch (err) {
//       console.error("Latest alarm error:", err);
//       return null;
//     }
//   };

//   const getSupplyHealthFromGroups = (groups) => {
//     if (!groups || groups.length === 0) return null;

//     for (const group of groups) {
//       for (const param of group.parameters || []) {
//         if (param.key_name === "Supply_H") {
//           return param.value; // 1 or 0
//         }
//       }
//     }

//     return null; // not found
//   };

//   const formatTimestamp = (ts) => {
//     if (!ts) return "N/A";
//     const date = new Date(ts);
//     return date.toLocaleString(); // clean format
//   };

//   const getData = (site, key) => site.telemetry?.modbus?.[0]?.[key];

//   const getText = (site, key) => (getData(site, key) === 1 ? "ON" : "OFF");

//   const getStatus = (site, key) => (getData(site, key) === 1 ? "green" : "red");

//   const getWater = (site) => {
//     const d = site.telemetry?.modbus?.[0];
//     if (!d) return 0;
//     if (d.Water_L_H) return 100;
//     if (d.Water_L_M) return 50;
//     if (d.Water_L_L) return 20;
//     return 0;
//   };

//   // const formatParamValue = (param) => {
//   //   const key = param.key_name || param.key || param.name || ""; // depends on your API
//   //   const val = param.value;

//   //   if (val === undefined || val === null) return "-";

//   //   // Detector Panels
//   //   if (key === "Det_Cpan_Sts" || key === "Det_Bpan_Sts") {
//   //     return val === 1 ? "Working" : "Not Working";
//   //   }

//   //   // Pressure
//   //   if (key.includes("Pr")) {
//   //     return `${(val / 100).toFixed(2)} Kg/cm²`;
//   //   }

//   //   // Status ON/OFF
//   //   if (key.includes("Sts") || key.includes("Status") || key.endsWith("FSts")) {
//   //     return val === 1 ? "ONLINE" : "OFFLINE";
//   //   }

//   //   // Mode AUTO/MANUAL
//   //   if (key.includes("Mod")) {
//   //     return val === 1 ? "AUTO" : "MANUAL";
//   //   }

//   //   // Trip / Fault
//   //   if (key.includes("Tr") || key.includes("Fault")) {
//   //     return val === 1 ? "FAULT" : "OK";
//   //   }

//   //   // Supply Health
//   //   if (key === "Supply_H") {
//   //     return val === 1 ? "HEALTHY" : "FAULT";
//   //   }

//   //   // Jockey Selection
//   //   if (key === "Jock_Pump_Sel") {
//   //     return val === 1 ? "SELECTED" : "OFF";
//   //   }

//   //   // Fuel
//   //   if (key === "Fuel_Low_Level") {
//   //     return val === 1 ? "FULL" : "LOW";
//   //   }

//   //   // Default fallback
//   //   return val === 1 ? "ON" : val === 0 ? "OFF" : val;
//   // };

//   const formatParamValue = (param) => {
//     const key = param.key_name || param.key || param.name || "";
//     const val = param.value;

//     if (val === undefined || val === null) return "-";

//     // =========================
//     // 🔥 SPECIAL CASE: TANK & WATER LEVELS
//     // =========================
//     const isTankOrWater =
//       key.startsWith("Upp_Tank_L") || key.startsWith("Water_L");

//     if (isTankOrWater) {
//       if (key.endsWith("_H")) return val === 1 ? "HIGH" : "LOW";
//       if (key.endsWith("_M")) return val === 1 ? "MEDIUM" : "LOW";
//       if (key.endsWith("_L")) return val === 1 ? "LOW" : "NORMAL";
//     }

//     // Detector Panels
//     if (key === "Det_Cpan_Sts" || key === "Det_Bpan_Sts") {
//       return val === 1 ? "Working" : "Not Working";
//     }

//     // Pressure
//     if (key.includes("Pr")) {
//       return `${(val / 100).toFixed(2)} Kg/cm²`;
//     }

//     // Status ON/OFF
//     if (key.includes("Sts") || key.includes("Status") || key.endsWith("FSts")) {
//       return val === 1 ? "ONLINE" : "OFFLINE";
//     }

//     // Mode AUTO/MANUAL
//     if (key.includes("Mod")) {
//       return val === 1 ? "AUTO" : "MANUAL";
//     }

//     // Trip / Fault
//     if (key.includes("Tr") || key.includes("Fault")) {
//       return val === 1 ? "FAULT" : "OK";
//     }

//     // Supply Health
//     if (key === "Supply_H") {
//       return val === 1 ? "HEALTHY" : "FAULT";
//     }

//     // Default fallback
//     return val === 1 ? "ON" : val === 0 ? "OFF" : val;
//   };

//   return (
//     <div className="dashboard-container">
//       {/* <CreateCustomer
//         open={showCustomerPopup}
//         onClose={() => setShowCustomerPopup(false)}
//         onSuccess={() => {
//           // ✅ Force the popup to close immediately
//           setShowCustomerPopup(false);

//           // ✅ Refresh data so the dashboard shows the new organization's sites
//           fetchSitesWithHealth();
//           fetchAssetsWithLocation();
//         }}
//       /> */}
//       <div className="alarms-header-main">
//         <div className="title-block">
//           <div className="header-text-group">
//             <h1>Sites Overview</h1>
//           </div>
//           {localStorage.getItem("role") === "SA" && (
//             <select
//               className="customer-dropdown"
//               value={selectedCustomer}
//               // onChange={(e) => {
//               //   const customerId = e.target.value;
//               //   setSelectedCustomer(customerId);
//               //   setLoading(true);   // show full loader
//               //   setSites([]);       // clear old sites immediately

//               //   fetchSitesWithHealth(customerId);
//               //   fetchAssetsWithLocation(customerId);
//               // }}
//               onChange={(e) => {
//                 const customerId = e.target.value;
//                 setSelectedCustomer(customerId);
//                 selectedCustomerRef.current = customerId;

//                 setLoading(true);
//                 setSites([]);

//                 fetchSitesWithHealth(customerId);
//                 fetchAssetsWithLocation(customerId);
//               }}
//             >
//               <option value="" disabled>
//                 Select Customer
//               </option>

//               {customers.map((customer) => (
//                 <option
//                   key={customer.tb_customer_id}
//                   value={customer.tb_customer_id}
//                 >
//                   {customer.customer_name}
//                 </option>
//               ))}
//             </select>
//           )}
//         </div>

//         <div className="header-actions">
//           <button className="trends-btn" onClick={() => navigate("/trends")}>
//             View Trends
//           </button>
//         </div>
//       </div>

//       {/* ✅ ADD HERE */}
//       {refreshing && <div className="refreshing-text">Updating...</div>}

//       {/* <div className="cards-container">
//         {loading ? (
//           <div className="loading-wrapper">
//             <div className="spinner"></div>
//             <p>Loading sites...</p>
//           </div> */}
//       <div className="cards-container">
//         {sites.length === 0 && loading ? (
//           <div className="loading-wrapper">
//             <div className="spinner"></div>
//             <p>Loading sites...</p>
//           </div>
//         ) : sites.length === 0 ? (
//           <div className="no-sites-message">No Sites Available</div>
//         ) : (
//           sites.map((site) => {
//             const supplyHealth = getSupplyHealthFromGroups(
//               site.groupedTelemetry,
//             );

//             // const d = site.telemetry?.modbus?.[0] || {};
//             // Updated logic to check number 1 (Healthy) or 0 (Fault)
//             // const borderColor = !site.isActive
//             //   ? "#ef4444"
//             //   : site.supplyHealth === 1
//             //     ? "#10b981"
//             //     : "#3b82f6";
//             return (
//               <div
//                 key={site.siteId}
//                 className="fire-card"
//               // onClick={() => setSelectedSite(site)}
//               >
//                 {/* HEADER */}
//                 {/* <div className="card-header"> */}
//                 <div className="site-title-wrapper">
//                   {/* LEFT SIDE */}
//                   <div className="site-left">
//                     <FontAwesomeIcon
//                       icon={faLocationDot}
//                       className="location-icon"
//                     />
//                     {/* <h3>{site.siteName}</h3> */}
//                     <div className="site-title-block">
//                       <h3 className="site-name">
//                         {loading ? "Loading Site..." : site.siteName}
//                       </h3>
//                       {site.deviceName && (
//                         <span className="device-name">({site.deviceName})</span>
//                       )}
//                     </div>
//                   </div>

//                   {/* RIGHT SIDE */}
//                   <div className="site-right">
//                     {supplyHealth !== null && (
//                       <span
//                         className={`badge ${supplyHealth === 1
//                           ? "healthy"
//                           : supplyHealth === 0
//                             ? "fault"
//                             : "offline"
//                           }`}
//                       >
//                         {supplyHealth === 1
//                           ? "HEALTHY"
//                           : supplyHealth === 0
//                             ? "FAULT"
//                             : "OFFLINE"}
//                       </span>
//                     )}

//                     {/* ✅ NEW: ONLINE / OFFLINE beside badge */}
//                     <div className="header-status">
//                       <span
//                         className={site.isActive ? "dot green" : "dot red"}
//                       ></span>
//                       <span className="status-text">
//                         {site.isActive ? "ONLINE" : "OFFLINE"}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 {/* GROUPED TELEMETRY */}
//                 {/* <div className="section"> */}
//                 {loading ? (
//                   <div className="card-loader">Loading telemetry...</div>
//                 ) : site.groupedTelemetry &&
//                   site.groupedTelemetry.length > 0 ? (
//                   <div className="group-grid">
//                     {" "}
//                     {/* 👈 NEW WRAPPER */}
//                     {site.groupedTelemetry.map((group, gIndex) => (
//                       <div key={gIndex} className="group-card">
//                         <h5 className="group-title">{group.group_name}</h5>

//                         <div className="status-grid">
//                           {group.parameters.map((param, pIndex) => (
//                             <div className="status-item" key={pIndex}>
//                               <span>{param.display_name}</span>

//                               <span
//                                 className={`tag ${param.value === 1
//                                   ? "green"
//                                   : param.value === 0
//                                     ? "red"
//                                     : "gray"
//                                   }`}
//                               >
//                                 {formatParamValue(param)}
//                               </span>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <p>No Data Available</p>
//                 )}
//                 {/* </div> */}

//                 <div className="last-update">
//                   {site.latestAlarms && site.latestAlarms.length > 0 ? (
//                     <div className="alarm-row">
//                       {site.latestAlarms.slice(0, 2).map((alarm, index) => (
//                         <div key={index} className="alarm-col">
//                           {/* NAME */}
//                           <div
//                             style={{ fontWeight: "600", marginBottom: "4px" }}
//                           >
//                             {alarm.name}
//                           </div>

//                           {/* ✅ SAME STATUS UI (UNCHANGED) */}
//                           <div style={{ fontSize: "12px", color: "#475569" }}>
//                             Status:{" "}
//                             <span
//                               style={{
//                                 color:
//                                   alarm.status === "CLEARED_UNACK"
//                                     ? "#10b981"
//                                     : "#ef4444",
//                                 fontWeight: "600",
//                               }}
//                             >
//                               {alarm.status}
//                             </span>
//                           </div>

//                           {/* TIME */}
//                           <div style={{ fontSize: "12px", marginTop: "4px" }}>
//                             Start: {formatTimestamp(alarm.startTs)}
//                           </div>

//                           <div style={{ fontSize: "12px" }}>
//                             End: {formatTimestamp(alarm.endTs)}
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   ) : (
//                     <span>No Alarms</span>
//                   )}
//                 </div>

//                 {/* FOOTER */}
//                 <div className="card-footer">
//                   <span
//                     className="view-detail"
//                     onClick={() => navigate(`/Dashboard_2/${site.siteId}`)}
//                   >
//                     View Detail Overview →
//                   </span>
//                 </div>
//               </div>
//             );
//           })
//         )}
//       </div>

//       {/* ================= MODAL POPUP ================= */}
//       {/* {selectedSite && (
//         <div className="modal-overlay" onClick={() => setSelectedSite(null)}>
//           <div
//             className="details-popup-content"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-header-popup">
//               <h2>{selectedSite.siteName}</h2>
//               <button className="close-x" onClick={() => setSelectedSite(null)}>
//                 &times;
//               </button>
//             </div>
//             <div className="modal-body-scroll">
              
//               <SiteStatusCard
//                 title="System Status"
//                 statusData={selectedSite.telemetry || {}}
//               />
//             </div>
//           </div>
//         </div>
//       )} */}

//       {/* MAP */}
//       <div className="map-container" style={{ marginTop: "40px" }}>
//         <h3>Site Locations</h3>

//         <MapContainer
//           center={
//             assets.length > 0 && assets[0].latitude
//               ? [assets[0].latitude, assets[0].longitude]
//               : [20.5937, 78.9629]
//           }
//           zoom={6}
//           style={{ height: "450px", width: "100%" }}
//         >
//           <TileLayer
//             attribution="&copy; OpenStreetMap contributors"
//             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//           />

//           {assets.map(
//             (asset) =>
//               asset.latitude &&
//               asset.longitude && (
//                 <Marker
//                   key={asset.id.id}
//                   position={[asset.latitude, asset.longitude]}
//                 >
//                   <Popup>
//                     <strong>{asset.name}</strong>
//                     <br />
//                     Lat: {asset.latitude}
//                     <br />
//                     Long: {asset.longitude}
//                     <br />
//                     Status:{" "}
//                     <span
//                       style={{
//                         color: sites.find((s) => s.siteId === asset.id.id)
//                           ?.isActive
//                           ? "green"
//                           : "red",
//                         fontWeight: "bold",
//                       }}
//                     >
//                       {sites.find((s) => s.siteId === asset.id.id)?.isActive
//                         ? "ONLINE"
//                         : "OFFLINE"}
//                     </span>
//                   </Popup>
//                 </Marker>
//               ),
//           )}
//         </MapContainer>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;



















import { useEffect, useState, useRef } from "react";
import "./dashboard.css";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { FaCircle, FaArrowRight, FaBell } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import "leaflet/dist/leaflet.css";
import toast from "react-hot-toast";
import SiteStatusCard from "../../StatusTile/SiteStatuscard.js";
import CreateCustomer from "./CreateCustomer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import apiService from "../../../utils/apiservice";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = process.env.REACT_APP_API_DJANGO_URL;

// Fix leaflet icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

const Dashboard = () => {
  const [sites, setSites] = useState([]);
  const [assets, setAssets] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedSite, setSelectedSite] = useState(null);
  const navigate = useNavigate();
  const selectedCustomerRef = useRef("");

  const [unreadCount, setUnreadCount] = useState(0);
  const lastAlarmTimeRef = useRef(0);
  const [showCustomerPopup, setShowCustomerPopup] = useState(false);
  const [refreshing, setRefreshing] = useState(false); // background refresh
  const [showAllCustomerSites, setShowAllCustomerSites] = useState(false);
  const [allCustomerSites, setAllCustomerSites] = useState([]);

  const formatDtmToDateTime = (dtm) => {
    if (!dtm || dtm.length < 14) return "N/A";
    const year = dtm.substring(0, 4);
    const month = dtm.substring(4, 6);
    const day = dtm.substring(6, 8);
    const hours = dtm.substring(8, 10);
    const minutes = dtm.substring(10, 12);
    const seconds = dtm.substring(12, 14);
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };
  useEffect(() => {
    // ⏳ Delay ONLY for organization check
    const timer = setTimeout(() => {
      checkCustomerStatus();
    }, 500);

    const init = async () => {
      setLoading(true);

      try {
        const customerId = await fetchCustomers();

        await Promise.all([
          fetchSitesWithHealth(customerId),
          fetchAssetsWithLocation(customerId),
          fetchAlarms(),
        ]);
      } finally {
        setLoading(false);
      }
    };

    init();

    // const interval = setInterval(() => {
    //   fetchSitesWithHealth();
    //   fetchAssetsWithLocation();
    //   fetchAlarms();
    // }, 60000);

    const interval = setInterval(() => {
      const currentCustomer =
        localStorage.getItem("role") === "SA"
          ? selectedCustomerRef.current
          : localStorage.getItem("customer_id");

      fetchSitesWithHealth(currentCustomer);
      fetchAssetsWithLocation(currentCustomer);
      fetchAlarms();
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const checkCustomerStatus = async () => {
    // ✅ Use consistent key
    const customerId = localStorage.getItem("customerId");
    if (customerId) {
      setShowCustomerPopup(false);
      return;
    }

    try {
      const token = localStorage.getItem("accessToken");
      if (!token) return;

      const response = await axios.get(`${API_URL}/api/check_organization/`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // ✅ Only show popup if API says false AND no localStorage
      if (!response.data?.status && !localStorage.getItem("customerId")) {
        setShowCustomerPopup(true);
      } else {
        setShowCustomerPopup(false);
        // ✅ Save customerId to localStorage if API provides it
        if (response.data.customerId) {
          localStorage.setItem("customerId", response.data.customerId);
        }
      }
    } catch (err) {
      console.error("Check org API error:", err);
      if (!localStorage.getItem("customerId")) {
        setShowCustomerPopup(true);
      } else {
        setShowCustomerPopup(false);
      }
    }
  };

  const fetchCustomers = async () => {
    const role = localStorage.getItem("role");

    // only Super Admin can fetch customer list
    if (role !== "SA") return;

    try {
      const token = localStorage.getItem("accessToken");

      // const res = await axios.get(`${API_URL}/api/get_customers/`, {
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //     Accept: "application/json",
      //   },
      // });
      const res = await apiService({
        url: `${API_URL}/api/get_customers/`,
        method: "GET",
      });
      const customerList = res.data || [];
      setCustomers(customerList);

      // if (customerList.length > 0) {
      //   const firstCustomerId = customerList[0].tb_customer_id;
      //   setSelectedCustomer(firstCustomerId);
      //   return firstCustomerId;
      // }
      if (customerList.length > 0) {
        const firstCustomerId = customerList[0].tb_customer_id;
        setSelectedCustomer(firstCustomerId);
        selectedCustomerRef.current = firstCustomerId;
        return firstCustomerId;
      }

      return null;
    } catch (err) {
      console.error("Customer fetch error:", err);
    }
  };

  const fetchSitesWithHealth = async (passedCustomerId = null) => {
    try {
      if (sites.length === 0) {
        setLoading(true); // only first load
      } else {
        setRefreshing(true); // background refresh
      }
      // setLoading(true); // ✅ START loading here
      const token = localStorage.getItem("accessToken");
      const role = localStorage.getItem("role");

      const customerId =
        role === "SA"
          ? passedCustomerId || selectedCustomer
          : localStorage.getItem("customer_id");
      const userId = localStorage.getItem("userId");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {},
      };
      let siteItems = [];
      if (role === "S") {
        // Supervisor
        const res = await axios.get(
          `${API_URL}/api/supervisor_sites/${userId}/`,
          config,
        ); // Convert response format
        siteItems = (res.data.sites || []).map((s) => ({
          asset_id: s.asset_id,
          name: s.name,
          latitude: s.latitude,
          longitude: s.longitude,
        }));
      } else if (role === "SE") {
        // ✅ Site Engineer
        const res = await axios.get(
          `${API_URL}/api/engineer_sites/${userId}/`,
          config,
        );

        siteItems = (res.data.sites || []).map((s) => ({
          asset_id: s.asset_id,
          name: s.site_name, // ⚠️ IMPORTANT (different key)
          latitude: s.latitude,
          longitude: s.longitude,
        }));
      } else {
        // 1. Get Customer Sites (Django Response: { "data": [{ "asset_id": "...", "name": "..." }] })
        const res = await axios.get(
          `${API_URL}/api/get_customer_sites/${customerId}/`,
          config,
        );
        siteItems = res.data.data || [];
      }
      // const siteItems = siteRes.data.data || [];

      const siteCards = await Promise.all(
        siteItems.map(async (site) => {
          const assetId = site.asset_id;
          const siteName = site.name;

          // IMPORTANT: config must contain Authorization, Accept, and Content-Type

          try {
            // 1. Get Site Devices - Now including config!
            const deviceRes = await axios.get(
              `${API_URL}/api/site_devices/${assetId}/`,
              config,
            );

            const devices = deviceRes.data.devices || [];
            const primaryDevice = devices[0];

            const deviceName =
              primaryDevice.name || primaryDevice.device_name || "";

            if (!primaryDevice) {
              return {
                siteId: assetId,
                siteName,
                supplyHealth: null,
                isActive: false,
              };
            }

            const deviceId = primaryDevice.device_id;

            const telemetryRes = await axios.get(
              `${API_URL}/api/device_telemetry/${deviceId}/?keys=data`,
              config,
            );

            const telData = telemetryRes.data.telemetry?.data || [];

            let parsedTelemetry = {};
            let modbusData = {};
            let isActive = false; // Default OFFLINE

            if (telData.length > 0 && telData[0].value !== null) {
              try {
                parsedTelemetry = JSON.parse(telData[0].value);
                modbusData = parsedTelemetry.modbus?.[0] || {};

                // Get telemetry timestamp
                const lastTelemetryTs = telData[0].ts;

                // Current time
                const now = Date.now();

                // Difference in minutes
                const diffMinutes = (now - lastTelemetryTs) / (1000 * 60);

                // ONLINE if telemetry received within last 2 minutes
                isActive = diffMinutes <= 2;

                console.log(
                  `${siteName} Last Telemetry Age: ${diffMinutes.toFixed(2)} mins`,
                );
              } catch (e) {
                console.error("JSON parse error for site:", siteName);
              }
            }

            // 2. Get Telemetry - Including config!
            // 2. Get Telemetry
            // const telemetryRes = await axios.get(
            //   `${API_URL}/api/device_telemetry/${deviceId}/?keys=data`,
            //   config,
            // );

            // const telData = telemetryRes.data.telemetry?.data || [];
            // let parsedTelemetry = {};
            // let modbusData = {};

            // // FIX: Check if value exists and is NOT null
            // if (telData.length > 0 && telData[0].value !== null) {
            //   try {
            //     parsedTelemetry = JSON.parse(telData[0].value);
            //     modbusData = parsedTelemetry.modbus?.[0] || {};
            //   } catch (e) {
            //     console.error("JSON parse error for site:", siteName);
            //   }
            // }

            // 3. Get Device Status - This will now be reached even if telemetry is null!
            // const statusRes = await axios.get(
            //   `${API_URL}/api/get_device_status/${deviceId}/`,
            //   config,
            // );

            // const isActive = statusRes.data.active ?? false;
            // const deviceName = statusRes.data.name ?? "";

            // ✅ NEW: Fetch grouped telemetry
            const groupedData = await fetchGroupedTelemetry(deviceId, config);
            // ✅ NEW: Fetch latest alarm
            const latestAlarm = await fetchLatestAlarms(deviceId, config);

            return {
              siteId: assetId,
              siteName,
              deviceId,
              deviceName,
              supplyHealth: modbusData.Supply_H ?? null,
              lastUpdated: parsedTelemetry.dtm
                ? formatDtmToDateTime(parsedTelemetry.dtm)
                : "N/A",
              isActive: isActive,
              telemetry: parsedTelemetry,
              groupedTelemetry: groupedData,
              latestAlarms: latestAlarm,
            };
          } catch (innerErr) {
            console.error(
              `Error processing site ${siteName}:`,
              innerErr.response?.data || innerErr.message,
            );
            return {
              siteId: assetId,
              siteName,
              supplyHealth: null,
              isActive: false,
            };
          }
        }),
      );
      setSites((prevSites) => {
        return siteCards.map((newSite) => {
          const oldSite = prevSites.find((s) => s.siteId === newSite.siteId);

          return JSON.stringify(oldSite) !== JSON.stringify(newSite)
            ? newSite
            : oldSite;
        });
      });
    } catch (err) {
      console.error("Master Site fetch error:", err);
    } finally {
      setLoading(false); // ✅ STOP loading ONLY after everything completes
      setRefreshing(false);
    }
  };

  const fetchAssetsWithLocation = async (passedCustomerId = null) => {
    try {
      const token = localStorage.getItem("accessToken");
      const role = localStorage.getItem("role");

      const customerId =
        role === "SA"
          ? passedCustomerId || selectedCustomer
          : localStorage.getItem("customer_id");
      const userId = localStorage.getItem("userId");

      let siteItems = [];
      let res;

      if (role === "S") {
        // Using your local DB Site data via the middle layer
        // Supervisor API
        const res = await axios.get(
          `${API_URL}/api/supervisor_sites/${userId}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            data: {},
          },
        );
        siteItems = (res.data.sites || []).map((s) => ({
          asset_id: s.asset_id,
          name: s.name,
          latitude: s.latitude,
          longitude: s.longitude,
        }));
      } else if (role === "SE") {
        const res = await axios.get(
          `${API_URL}/api/engineer_sites/${userId}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            data: {},
          },
        );

        siteItems = (res.data.sites || []).map((s) => ({
          asset_id: s.asset_id,
          name: s.site_name,
          latitude: s.latitude,
          longitude: s.longitude,
        }));
      } else {
        // Customer API
        const res = await axios.get(
          `${API_URL}/api/get_customer_sites/${customerId}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            data: {},
          },
        );

        siteItems = res.data.data || [];
      }

      const assetsWithLoc = (siteItems || []).map((site) => ({
        id: { id: site.asset_id },
        name: site.name,
        latitude: site.latitude,
        longitude: site.longitude,
      }));

      setAssets(assetsWithLoc);
      // setLoading(false);
    } catch (err) {
      console.error("Asset location fetch error:", err);
      // setLoading(false);
    }
  };


  const fetchAllAssignmentSites = async () => {
  try {
    const response = await apiService({
      url: `/api/get_sites_for_assignment/`,
      method: "GET",
      params: {},
    });

    const merged = [
      ...(response?.data?.assigned_sites || []),
      ...(response?.data?.unassigned_sites || [])
    ];

    setAllCustomerSites(
      merged.map((site, index) => ({
        id: index + 1,
        ...site
      }))
    );

  } catch (err) {
    console.error("Fetch all customer sites error:", err);
  }
};

  const handleAllSitesToggle = (checked) => {

    const role = localStorage.getItem("role");

    // Only SA can use this
    if (role !== "SA") {
      return;
    }

    setShowAllCustomerSites(checked);

    if (checked && allCustomerSites.length === 0) {
      fetchAllAssignmentSites();
    }
  };

  const fetchAlarms = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      // Ensure this URL matches your Django path exactly
      const res = await axios.get(`${API_URL}/api/get_alarms_notification/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          // "Content-Type": "application/json"
        },
      });

      const alarmList = res.data.data || [];
      const active = alarmList.filter((a) => !a.cleared);

      if (alarmList.length > 0) {
        const newestTime = alarmList[0].createdTime;
        if (
          lastAlarmTimeRef.current !== 0 &&
          newestTime > lastAlarmTimeRef.current
        ) {
          toast.error("🚨 New Alarm Triggered!");
          localStorage.removeItem("alarmsViewed");
        }
        lastAlarmTimeRef.current = newestTime;
      }

      setUnreadCount(
        localStorage.getItem("alarmsViewed") === "true" ? 0 : active.length,
      );
    } catch (err) {
      console.error("Alarm fetch error:", err);
    }
  };

  const fetchGroupedTelemetry = async (deviceId, config) => {
    try {
      const res = await axios.get(
        `${API_URL}/api/get_grouped_telemetry/${deviceId}/`,
        config,
      );

      return res.data?.groups || [];
    } catch (err) {
      console.error("Grouped telemetry error:", err);
      return [];
    }
  };

  const fetchLatestAlarms = async (deviceId, config) => {
    try {
      const res = await axios.get(
        `${API_URL}/api/get_latest_alarms/?deviceId=${deviceId}`,
        config,
      );

      // API returns array in data
      const alarms = res.data?.data || res.data || [];

      return alarms || []; // take latest only
    } catch (err) {
      console.error("Latest alarm error:", err);
      return null;
    }
  };

  const getSupplyHealthFromGroups = (groups) => {
    if (!groups || groups.length === 0) return null;

    for (const group of groups) {
      for (const param of group.parameters || []) {
        if (param.key_name === "Supply_H") {
          return param.value; // 1 or 0
        }
      }
    }

    return null; // not found
  };

  const formatTimestamp = (ts) => {
    if (!ts) return "N/A";
    const date = new Date(ts);
    return date.toLocaleString(); // clean format
  };

  const getData = (site, key) => site.telemetry?.modbus?.[0]?.[key];

  const getText = (site, key) => (getData(site, key) === 1 ? "ON" : "OFF");

  const getStatus = (site, key) => (getData(site, key) === 1 ? "green" : "red");

  const getWater = (site) => {
    const d = site.telemetry?.modbus?.[0];
    if (!d) return 0;
    if (d.Water_L_H) return 100;
    if (d.Water_L_M) return 50;
    if (d.Water_L_L) return 20;
    return 0;
  };

  // const formatParamValue = (param) => {
  //   const key = param.key_name || param.key || param.name || ""; // depends on your API
  //   const val = param.value;

  //   if (val === undefined || val === null) return "-";

  //   // Detector Panels
  //   if (key === "Det_Cpan_Sts" || key === "Det_Bpan_Sts") {
  //     return val === 1 ? "Working" : "Not Working";
  //   }

  //   // Pressure
  //   if (key.includes("Pr")) {
  //     return `${(val / 100).toFixed(2)} Kg/cm²`;
  //   }

  //   // Status ON/OFF
  //   if (key.includes("Sts") || key.includes("Status") || key.endsWith("FSts")) {
  //     return val === 1 ? "ONLINE" : "OFFLINE";
  //   }

  //   // Mode AUTO/MANUAL
  //   if (key.includes("Mod")) {
  //     return val === 1 ? "AUTO" : "MANUAL";
  //   }

  //   // Trip / Fault
  //   if (key.includes("Tr") || key.includes("Fault")) {
  //     return val === 1 ? "FAULT" : "OK";
  //   }

  //   // Supply Health
  //   if (key === "Supply_H") {
  //     return val === 1 ? "HEALTHY" : "FAULT";
  //   }

  //   // Jockey Selection
  //   if (key === "Jock_Pump_Sel") {
  //     return val === 1 ? "SELECTED" : "OFF";
  //   }

  //   // Fuel
  //   if (key === "Fuel_Low_Level") {
  //     return val === 1 ? "FULL" : "LOW";
  //   }

  //   // Default fallback
  //   return val === 1 ? "ON" : val === 0 ? "OFF" : val;
  // };

  const formatParamValue = (param) => {
    const key = param.key_name || param.key || param.name || "";
    const val = param.value;

    if (val === undefined || val === null) return "-";

    // =========================
    // 🔥 SPECIAL CASE: TANK & WATER LEVELS
    // =========================
    const isTankOrWater =
      key.startsWith("Upp_Tank_L") || key.startsWith("Water_L");

    if (isTankOrWater) {
      if (key.endsWith("_H")) return val === 1 ? "HIGH" : "LOW";
      if (key.endsWith("_M")) return val === 1 ? "MEDIUM" : "LOW";
      if (key.endsWith("_L")) return val === 1 ? "LOW" : "NORMAL";
    }

    // Detector Panels
    if (key === "Det_Cpan_Sts" || key === "Det_Bpan_Sts") {
      return val === 1 ? "Working" : "Not Working";
    }

    // Pressure
    if (key.includes("Pr")) {
      return `${(val / 100).toFixed(2)} Kg/cm²`;
    }

    // Status ON/OFF
    if (key.includes("Sts") || key.includes("Status") || key.endsWith("FSts")) {
      return val === 1 ? "ONLINE" : "OFFLINE";
    }

    // Mode AUTO/MANUAL
    if (key.includes("Mod")) {
      return val === 1 ? "AUTO" : "MANUAL";
    }

    // Trip / Fault
    if (key.includes("Tr") || key.includes("Fault")) {
      return val === 1 ? "FAULT" : "OK";
    }

    // Supply Health
    if (key === "Supply_H") {
      return val === 1 ? "HEALTHY" : "FAULT";
    }

    // Default fallback
    return val === 1 ? "ON" : val === 0 ? "OFF" : val;
  };

  return (
    <div className="dashboard-container">
      {/* <CreateCustomer
        open={showCustomerPopup}
        onClose={() => setShowCustomerPopup(false)}
        onSuccess={() => {
          // ✅ Force the popup to close immediately
          setShowCustomerPopup(false);

          // ✅ Refresh data so the dashboard shows the new organization's sites
          fetchSitesWithHealth();
          fetchAssetsWithLocation();
        }}
      /> */}
      <div className="alarms-header-main">
        <div className="title-block">
          <div className="header-text-group">
            <h1>Sites Overview</h1>
          </div>
          {localStorage.getItem("role") === "SA" && (
            <select
              className="customer-dropdown"
              value={selectedCustomer}
              // onChange={(e) => {
              //   const customerId = e.target.value;
              //   setSelectedCustomer(customerId);
              //   setLoading(true);   // show full loader
              //   setSites([]);       // clear old sites immediately

              //   fetchSitesWithHealth(customerId);
              //   fetchAssetsWithLocation(customerId);
              // }}
              onChange={(e) => {
                const customerId = e.target.value;
                setSelectedCustomer(customerId);
                selectedCustomerRef.current = customerId;

                setLoading(true);
                setSites([]);

                fetchSitesWithHealth(customerId);
                fetchAssetsWithLocation(customerId);
              }}
            >
              <option value="" disabled>
                Select Customer
              </option>

              {customers.map((customer) => (
                <option
                  key={customer.tb_customer_id}
                  value={customer.tb_customer_id}
                >
                  {customer.customer_name}
                </option>
              ))}
            </select>
          )}
        </div>

        <div className="header-actions">
          <button className="trends-btn" onClick={() => navigate("/trends")}>
            View Trends
          </button>
        </div>
      </div>

      {/* ✅ ADD HERE */}
      {refreshing && <div className="refreshing-text">Updating...</div>}

      {/* <div className="cards-container">
        {loading ? (
          <div className="loading-wrapper">
            <div className="spinner"></div>
            <p>Loading sites...</p>
          </div> */}
      <div className="cards-container">
        {sites.length === 0 && loading ? (
          <div className="loading-wrapper">
            <div className="spinner"></div>
            <p>Loading sites...</p>
          </div>
        ) : sites.length === 0 ? (
          <div className="no-sites-message">No Sites Available</div>
        ) : (
          sites.map((site) => {
            const supplyHealth = getSupplyHealthFromGroups(
              site.groupedTelemetry,
            );

            // const d = site.telemetry?.modbus?.[0] || {};
            // Updated logic to check number 1 (Healthy) or 0 (Fault)
            // const borderColor = !site.isActive
            //   ? "#ef4444"
            //   : site.supplyHealth === 1
            //     ? "#10b981"
            //     : "#3b82f6";
            return (
              <div
                key={site.siteId}
                className="fire-card"
              // onClick={() => setSelectedSite(site)}
              >
                {/* HEADER */}
                {/* <div className="card-header"> */}
                <div className="site-title-wrapper">
                  {/* LEFT SIDE */}
                  <div className="site-left">
                    <FontAwesomeIcon
                      icon={faLocationDot}
                      className="location-icon"
                    />
                    {/* <h3>{site.siteName}</h3> */}
                    <div className="site-title-block">
                      <h3 className="site-name">
                        {loading ? "Loading Site..." : site.siteName}
                      </h3>
                      {site.deviceName && (
                        <span className="device-name">({site.deviceName})</span>
                      )}
                    </div>
                  </div>

                  {/* RIGHT SIDE */}
                  <div className="site-right">
                    {supplyHealth !== null && (
                      <span
                        className={`badge ${supplyHealth === 1
                          ? "healthy"
                          : supplyHealth === 0
                            ? "fault"
                            : "offline"
                          }`}
                      >
                        {supplyHealth === 1
                          ? "HEALTHY"
                          : supplyHealth === 0
                            ? "FAULT"
                            : "OFFLINE"}
                      </span>
                    )}

                    {/* ✅ NEW: ONLINE / OFFLINE beside badge */}
                    <div className="header-status">
                      <span
                        className={site.isActive ? "dot green" : "dot red"}
                      ></span>
                      <span className="status-text">
                        {site.isActive ? "ONLINE" : "OFFLINE"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* GROUPED TELEMETRY */}
                {/* <div className="section"> */}
                {loading ? (
                  <div className="card-loader">Loading telemetry...</div>
                ) : site.groupedTelemetry &&
                  site.groupedTelemetry.length > 0 ? (
                  <div className="group-grid">
                    {" "}
                    {/* 👈 NEW WRAPPER */}
                    {site.groupedTelemetry.map((group, gIndex) => (
                      <div key={gIndex} className="group-card">
                        <h5 className="group-title">{group.group_name}</h5>

                        <div className="status-grid">
                          {group.parameters.map((param, pIndex) => (
                            <div className="status-item" key={pIndex}>
                              <span>{param.display_name}</span>

                              <span
                                className={`tag ${param.value === 1
                                  ? "green"
                                  : param.value === 0
                                    ? "red"
                                    : "gray"
                                  }`}
                              >
                                {formatParamValue(param)}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>No Data Available</p>
                )}
                {/* </div> */}

                <div className="last-update">
                  {site.latestAlarms && site.latestAlarms.length > 0 ? (
                    <div className="alarm-row">
                      {site.latestAlarms.slice(0, 2).map((alarm, index) => (
                        <div key={index} className="alarm-col">
                          {/* NAME */}
                          <div
                            style={{ fontWeight: "600", marginBottom: "4px" }}
                          >
                            {alarm.name}
                          </div>

                          {/* ✅ SAME STATUS UI (UNCHANGED) */}
                          <div style={{ fontSize: "12px", color: "#475569" }}>
                            Status:{" "}
                            <span
                              style={{
                                color:
                                  alarm.status === "CLEARED_UNACK"
                                    ? "#10b981"
                                    : "#ef4444",
                                fontWeight: "600",
                              }}
                            >
                              {alarm.status}
                            </span>
                          </div>

                          {/* TIME */}
                          <div style={{ fontSize: "12px", marginTop: "4px" }}>
                            Start: {formatTimestamp(alarm.startTs)}
                          </div>

                          <div style={{ fontSize: "12px" }}>
                            End: {formatTimestamp(alarm.endTs)}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <span>No Alarms</span>
                  )}
                </div>

                {/* FOOTER */}
                <div className="card-footer">
                  <span
                    className="view-detail"
                    onClick={() => navigate(`/Dashboard_2/${site.siteId}`)}
                  >
                    View Detail Overview →
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* ================= MODAL POPUP ================= */}
      {/* {selectedSite && (
        <div className="modal-overlay" onClick={() => setSelectedSite(null)}>
          <div
            className="details-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header-popup">
              <h2>{selectedSite.siteName}</h2>
              <button className="close-x" onClick={() => setSelectedSite(null)}>
                &times;
              </button>
            </div>
            <div className="modal-body-scroll">
              
              <SiteStatusCard
                title="System Status"
                statusData={selectedSite.telemetry || {}}
              />
            </div>
          </div>
        </div>
      )} */}


      <div className="map-container" style={{ marginTop: "40px" }}>

        {/* <h3>Site Locations</h3> */}
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "15px"
        }}>

          <h3>Site Locations</h3>

          {
            localStorage.getItem("role") === "SA" && (
              <label>
                <input
                  type="checkbox"
                  checked={showAllCustomerSites}
                  onChange={(e) =>
                    handleAllSitesToggle(e.target.checked)
                  }
                />

                Show All Customer Sites
              </label>
            )
          }

        </div>

        <MapContainer
          center={
            assets.length > 0 && assets[0].latitude
              ? [assets[0].latitude, assets[0].longitude]
              : [20.5937, 78.9629]
          }
          zoom={6}
          style={{ height: "450px", width: "100%" }}
        >
          <TileLayer
            attribution="&copy; OpenStreetMap contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {/* {assets.map( */}
          {(showAllCustomerSites ? allCustomerSites : assets).map(
            (asset) =>
              asset.latitude &&
              asset.longitude && (
                // <Marker
                //   key={asset.id.id}
                //   position={[asset.latitude, asset.longitude]}
                // >

                <Marker
                  key={asset.asset_id || asset.id?.id}
                  position={[
                    asset.latitude,
                    asset.longitude
                  ]}
                >
                  <Popup>
                    <strong>{asset.name}</strong>
                    <br />
                    Lat: {asset.latitude}
                    <br />
                    Long: {asset.longitude}
                    <br />
                    Status:{" "}
                    <span
                      style={{
                        color: sites.find((s) => s.siteId === (asset.asset_id || asset.id.id))
                          ?.isActive
                          ? "green"
                          : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {sites.find((s) => s.siteId === asset.id.id)?.isActive
                        ? "ONLINE"
                        : "OFFLINE"}
                    </span>
                  </Popup>
                </Marker>
              ),
          )}
        </MapContainer>
      </div>
    </div>
  );
};

export default Dashboard;

